import React from 'react';
import { Carousel } from "react-responsive-carousel";
import CarouselMulti from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const Legacy = (props) => {
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };
    return (
        <CarouselMulti
            ssr
            deviceType="desktop"
            infinite={true}
            showDots={true}
            autoPlay={true}
            autoPlaySpeed={5000}
            responsive={responsive}
        >
            <div className="relative">
                <div className="md:block hidden">
                    <img
                        className="object-fit object-bottom w-screen home-img"
                        src="/assets/static/images/Our legacy-01.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-fit object-bottom w-screen" 
                        src="/assets/static/images/Our legacy-01-sm.jpg"
                        alt=""
                    />
                </div>
            </div>
            <div className="relative">
                <div className="md:block hidden">
                    <img
                        className="object-fit object-bottom w-screen home-img"
                        src="/assets/static/images/Our legacy-02.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-fit object-bottom w-screen"
                        src="/assets/static/images/Our legacy-02-sm.jpg"
                        alt=""
                    />
                </div>
            </div>
            <div className="relative">
                <div className="md:block hidden">
                    <img
                        className="object-fit object-bottom w-screen home-img"
                        src="/assets/static/images/Our legacy-03.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-fit object-bottom w-screen" 
                        src="/assets/static/images/Our legacy-03-sm.jpg"
                        alt=""
                    />
                </div>
            </div>
        </CarouselMulti>
    );
}

export default Legacy;